/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AdminUpdateGlobalSyncValueSchemaVersionsRequest} from '@cash-web/protos/squareup/cash/clientsync/service.pb'
import {AdminUpdateGlobalSyncValueSchemaVersionsResponse} from '@cash-web/protos/squareup/cash/clientsync/service.pb'


export const adminUpdateGlobalSyncValueSchemaVersions = (request: AdminUpdateGlobalSyncValueSchemaVersionsRequest, options?: CashRequestOptions) => post<AdminUpdateGlobalSyncValueSchemaVersionsRequest, AdminUpdateGlobalSyncValueSchemaVersionsResponse>("/2.0/cash/admin-update-global-sync-value-schema-versions", request, {...options, rejectOnError: true })